import Logger from '@/core/services/Logger'

const logger = Logger.makeSectionLogger('MAIN_DATA_LOAD')

export default function (message: string) {
    const time = Date.now()

    return function () {
        const diff = Date.now() - time
        logger.log(message, Math.round(diff / 1000), 's', `(${diff}ms)`)
        return diff
    }
}
